import React from "react";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Home from "../components/Home"; 
function App() {
  return (
    <div>
      <Layout>
        <Seo/>
        <Home/>
      </Layout>
    </div>

  );
}

export default App;
